module.exports = __webpack_public_path__ + "static/notes-app-cover-e79aa8558bef3b15e95f26d3b5770e64.png";